export default __webpack_public_path__ + "static/media/Report_Black.aa492ae5.webp";